import { useNavigate } from "react-router-dom";
import "./Hello.scss";
import KeyboardArrows from "./KeyboardArrows/Keyboard";
import SnakeGame from "./SnakeGame/SnakeGame";
import { useState } from "react";

const viseIcon = (
  <svg
    width="7"
    height="6"
    viewBox="0 0 7 6"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0.460938 5.56574L5.99951 0.976349M0.460938 0.976349L5.99951 5.56574"
      stroke="#0c1616"
    />
  </svg>
);
function HelloPage() {
  const navigate = useNavigate();
  const [snake, setSnake] = useState(0);
  let leftFood = (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
    >
      <g opacity="0.3">
        <circle
          opacity="0.1"
          cx="11.2303"
          cy="11.0379"
          r="10.3456"
          fill="#43D9AD"
        />
        <circle
          opacity="0.2"
          cx="11.2303"
          cy="11.0379"
          r="7.34558"
          fill="#43D9AD"
        />
        <circle cx="11.2305" cy="11.0379" r="4" fill="#43D9AD" />
      </g>
    </svg>
  );
  let food = (
    <svg
      width="22"
      height="21"
      viewBox="0 0 22 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle
        opacity="0.1"
        cx="10.9227"
        cy="10.5377"
        r="10.3456"
        fill="#43D9AD"
      />
      <circle
        opacity="0.2"
        cx="10.9227"
        cy="10.5377"
        r="7.34558"
        fill="#43D9AD"
      />
      <circle cx="10.9229" cy="10.5377" r="4" fill="#43D9AD" />
    </svg>
  );
  return (
    <div className="hello-page">
      <div className="green-bull"></div>
      <div className="blue-bull"></div>
      <div className="hello-page__description-container">
        <div className="hello-page__description">
          <div className="hello-page__description__hi">Hi all. I am</div>
          <div className="hello-page__description__name">
            <span>Hamza</span>
            <span> Rihani</span>
          </div>
          <div className="hello-page__description__job">
            {"> Full Stack developer"}
          </div>
          <div className="hello-page__description__comment comment__one">
            {"// complete the game to continue"}
          </div>
          <div className="hello-page__description__comment comment__two">
            {"// you can also see it on my Github page"}
          </div>
          <div className="hello-page__description__comment comment__three">
            {"// find my profile on Github:"}
          </div>
          <div className="hello-page__description__git-link">
            <span className="hello-page__description__git-link__const">
              const
            </span>
            <span className="hello-page__description__git-link__const-name">
              githubLink
            </span>
            =
            <span className="hello-page__description__git-link__link">
              “https://github.com/hamzarihani”
            </span>
          </div>
        </div>
      </div>
      <div className="hello-page__game-container">
        <div className="hello-page__game-panel">
          <div className="hello-page__game-panel__game-box">
            <SnakeGame
              onChange={(e: any) => {
                setSnake(e);
              }}
            />
          </div>
          <div className="hello-page__game-panel__game-keyboard-box">
            <KeyboardArrows onClickArrow={(e) => {}} />
            <div className="hello-page__game-panel__left-food-box">
              <div>{"// left food"}</div>
              <div>
                {[0, 1, 2, 3, 4, 5, 6, 7, 8, 9].map((item, key) => (
                  <span key={key}>{snake - 4 > key ? food : leftFood}</span>
                ))}
              </div>
            </div>
            <div
              className="hello-page__game-panel__game-skip"
              onClick={() => navigate("/_about-me")}
            >
              skip
            </div>
          </div>
          <div
            style={{ top: "12px", left: "12px" }}
            className="hello-page__game-panel__vise"
          >
            {viseIcon}
          </div>
          <div
            style={{ top: "12px", right: "12px" }}
            className="hello-page__game-panel__vise"
          >
            {viseIcon}
          </div>
          <div
            style={{ bottom: "12px", left: "12px" }}
            className="hello-page__game-panel__vise"
          >
            {viseIcon}
          </div>
          <div
            style={{ bottom: "12px", right: "12px" }}
            className="hello-page__game-panel__vise"
          >
            {viseIcon}
          </div>
        </div>
      </div>
    </div>
  );
}

export default HelloPage;
